import { toast } from "react-hot-toast";
import axiosInstance from "./axiosInstance";

const showErrorToast = (error) => {
  const errorMessage =
    error.response?.data?.message || error.message || "Something went wrong";
  toast.error(errorMessage);
};

// Reusable API Methods
export const getApi = async ({ apiUrl }, showError = false) => {
  let headers = {};

  try {
    const response = await axiosInstance.get(`${apiUrl}`, {
      method: "GET",
      headers,
    });

    return response.data;
  } catch (error) {
    if (showError) showErrorToast(error);
    // showErrorToast(error);
    throw new Error(error.message || "Something went wrong");
  }
};

// export const postApi = async ({ apiUrl, data = {} }) => {
//   let headers = {
//     "Content-Type": "application/json",
//   };

//   try {
//     const response = await axiosInstance.post(`${apiUrl}`, {
//       method: "POST",
//       headers,
//       body: JSON.stringify(data),
//     });

//     return response.data;
//   } catch (error) {
//     showErrorToast(error);
//     throw new Error(error.message || "Something went wrong");
//   }
// };
export const postApi = async (
  { apiUrl, data = {}, token = null },
  showError = false,
) => {
  //  let headers = {
  //   "Content-Type": "application/json",
  // };
  let headers = {};
  if (!(data instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  try {
    const response = await axiosInstance.post(apiUrl, data, { headers });
    return response.data;
  } catch (error) {
    const responseData = error.response?.data;

    // ✅ Allow access to API errors like 400 with custom message
    if (responseData) {
      if (showError);
      return responseData; // <- return this even on 400, 403, etc.
    }

    // Default fallback
    if (showError);
    throw new Error(error.message || "Something went wrong");
  }
};

export const putApi = async ({ apiUrl, data = {}, token = null }) => {
  let headers = {};
  if (!(data instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  try {
    const response = await axiosInstance.put(apiUrl, data, { headers });

    return response.data;
  } catch (error) {
    showErrorToast(error);
    throw new Error(error.message || "Something went wrong");
  }
};

export const patchApi = async (
  { apiUrl, data = {}, token = null },
  showError = true,
) => {
  let headers = {};
  if (!(data instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  try {
    console.log("PATCH Request to:", apiUrl); // Debugging Log
    const response = await axiosInstance.patch(apiUrl, data, { headers });

    return response.data;
  } catch (error) {
    if (showError) showErrorToast(error);
    let apiErrorMessage = "";
    if (error.response?.data) {
      if (typeof error.response.data === "object") {
        apiErrorMessage = error.response.data.message;
      } else if (typeof error.response.data === "string") {
        try {
          const parsed = JSON.parse(error.response.data);
          apiErrorMessage =
            parsed.message || parsed.error || error.response.data;
        } catch (e) {
          apiErrorMessage = error.response.data;
        }
      }
    }
    if (!apiErrorMessage) {
      apiErrorMessage = error.message || "Something went wrong";
    }
    throw new Error(apiErrorMessage);
  }
};

export const deleteApi = async ({ apiUrl, data = {} }) => {
  let headers = {};
  if (!(data instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  try {
    const response = await axiosInstance.delete(`${apiUrl}`, {
      headers,
      data: data, // Axios delete payload goes in config.data
    });

    return response.data;
  } catch (error) {
    showErrorToast(error);
    throw new Error(error.message || "Something went wrong");
  }
};
